import { useState, useEffect } from "react";
import { loadVendorIdByDepartment } from "../services/vendorEnquiryService";
import { loadVendorListByEnquiryID } from "../services/vendorEnquiryService";
const useVendorEnquiryIDByDepartmentID = (editShiftAssignmentID, selectedDepartmentID) => {
    const [vendorIDList, setVendorIDList] = useState([]);
    const [selectedVendoIdList, setSelectedVendoIdList] = useState([]);
    const [selectedVendoIdListID, setSelectedVendoIdListID] = useState([]);
    const [isShiftRoasterDataLoaded, setIsShiftRoasterDataLoaded] = useState(false);

    const [vendorList, setVendorList] = useState([]);
    const [selectedVendoList, setSelectedVendoList] = useState([]);
    const [selectedVendoListID, setSelectedVendoListID] = useState([]);

    const fetchVendorIdList = async (selectedID = null, mode,requestid=null) => {
        const para = {
            p_companyid: localStorage.getItem("companyid"),
            p_plantid: 1,
            p_id_department: selectedID
        };

        if (selectedID && selectedID !== 0) {
            try {
                //loadShifRosterEmployeeListByDepartmentID
                const data = await loadVendorIdByDepartment(para);
                if (data && data.length > 0) {
                    setVendorIDList(data);

                    const initialDepartment = data.find((dept) => dept.id_request === requestid);

                    if (initialDepartment) { // ✅ Corrected check
                        setSelectedVendoIdList(initialDepartment);
                        setSelectedVendoIdListID(initialDepartment.id_request);
                        setIsShiftRoasterDataLoaded(true);
                    }
                }
                else {
                    setVendorIDList([]);
                }
            } catch (error) {
                // CallMessage("error", error.message, "Error");
            }
        }
        else {
            setVendorIDList([]);
        }
    };

    const fetchVendorListByEnquiryID = async (selectedID = null, mode,requestid=null) => {
        const para = {
            p_companyid: localStorage.getItem("companyid"),
            p_plantid: 1,
            p_id_enquiry: selectedID
        };

        if (selectedID && selectedID !== 0) {
            try {
                //loadVenodrListByEnquiryID
                const data = await loadVendorListByEnquiryID(para);
                if (data && data.length > 0) {
                    setVendorList(data);

                    // const initialDepartment = data.find((dept) => dept.id_party === requestid);

                    setSelectedVendoList(data[0]);
                    setSelectedVendoListID(data[0].id_party);          
                }
                else {
                    setVendorIDList([]);
                }
            } catch (error) {
                // CallMessage("error", error.message, "Error");
            }
        }
        else {
            setVendorIDList([]);
        }
    };

    // Load departments when the component mounts
    useEffect(() => {
        if (!isShiftRoasterDataLoaded && editShiftAssignmentID === 0) {
            fetchVendorIdList();
            fetchVendorListByEnquiryID();
        }
    }, [isShiftRoasterDataLoaded, editShiftAssignmentID]);

    // Function to load department based on selected ID 

    const loadVenodrIDByDepartmentID = async (selectedID, mode,requestid) => {
        await fetchVendorIdList(selectedID, mode,requestid);
    };

    const loadVenodrListByEnquiryIDLocal = async (selectedID, mode,requestid) => {
        await fetchVendorListByEnquiryID(selectedID, mode,requestid);
    };

    return {
        vendorIDList,
        selectedVendoIdList,
        selectedVendoIdListID,
        setSelectedVendoIdList,
        setSelectedVendoIdListID,
        loadVenodrIDByDepartmentID,
        loadVenodrListByEnquiryIDLocal,
        vendorList,
        selectedVendoList,
        selectedVendoListID,
        setSelectedVendoList,
        setSelectedVendoListID,
    };
};

export default useVendorEnquiryIDByDepartmentID;